// ABOUTME: Applies theme preference to HTML element
// ABOUTME: Handles system preference detection and persistence

'use client'

import { useEffect } from 'react'
import { ThemeStoreProvider, useThemeStore } from '@/lib/store/themeStore'

function ThemeApplier({ children }: { children: React.ReactNode }) {
  const { mode, setResolvedMode } = useThemeStore()

  useEffect(() => {
    // Detect system preference
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const updateTheme = () => {
      const resolved: 'light' | 'dark' =
        mode !== 'system' ? mode : mediaQuery.matches ? 'dark' : 'light'

      setResolvedMode(resolved)

      // Apply theme to HTML element
      const html = document.documentElement
      if (resolved === 'dark') {
        html.classList.add('dark')
      } else {
        html.classList.remove('dark')
      }
    }

    updateTheme()

    // Listen for system preference changes
    mediaQuery.addEventListener('change', updateTheme)
    return () => mediaQuery.removeEventListener('change', updateTheme)
  }, [mode, setResolvedMode])

  return <>{children}</>
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <ThemeStoreProvider>
      <ThemeApplier>{children}</ThemeApplier>
    </ThemeStoreProvider>
  )
}
